/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} About_DegreeInputs */

const en_about_degree = /** @type {(inputs: About_DegreeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`BSc in CSE`)
};

const ar_about_degree = /** @type {(inputs: About_DegreeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`بكالوريوس علوم الحاسوب`)
};

const bn_about_degree = /** @type {(inputs: About_DegreeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`CSE-তে BSc`)
};

const de_about_degree = /** @type {(inputs: About_DegreeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`BSc in CSE`)
};

const es_about_degree = /** @type {(inputs: About_DegreeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Licenciatura en ESO`)
};

const fr_about_degree = /** @type {(inputs: About_DegreeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`BSc en CSE`)
};

const pt_about_degree = /** @type {(inputs: About_DegreeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Licenciatura em CSE`)
};

const zh_about_degree = /** @type {(inputs: About_DegreeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`CSE 理学学士`)
};

const tr_about_degree = /** @type {(inputs: About_DegreeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ÖAM'de Lisans`)
};

const ru_about_degree = /** @type {(inputs: About_DegreeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Бакалавр в области CSE`)
};

const pl_about_degree = /** @type {(inputs: About_DegreeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Licencjat w CSE`)
};

/**
* | output |
* | --- |
* | "BSc in CSE" |
*
* @param {About_DegreeInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
export const about_degree = /** @type {((inputs?: About_DegreeInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<About_DegreeInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_about_degree(inputs)
	if (locale === "bn") return bn_about_degree(inputs)
	if (locale === "de") return de_about_degree(inputs)
	if (locale === "es") return es_about_degree(inputs)
	if (locale === "fr") return fr_about_degree(inputs)
	if (locale === "pt") return pt_about_degree(inputs)
	if (locale === "zh") return zh_about_degree(inputs)
	if (locale === "tr") return tr_about_degree(inputs)
	if (locale === "ru") return ru_about_degree(inputs)
	if (locale === "pl") return pl_about_degree(inputs)
	return en_about_degree(inputs)
});